import urlcat from 'urlcat';
import { fetchWrapped, PostOptions } from './';

import { contentApiV3, contentV3ApiV3 } from './endpoints';

//for SSR:
//@params: reqHeaders: { 'cookie': string, 'user-agent': string, 'x-real-ip': string, 'x-forwarded-for': string, 'x-request-id': string }
//for CSR:
//@params : reqHeaders: null
const getBlogData = async (reqHeaders) =>
  await fetchWrapped(
    urlcat(contentV3ApiV3, '/blog/posts'),
    new PostOptions({ bodyObject: reqHeaders ? { headers: reqHeaders } : {} })
  );
const getShopInfo = async (shopWebsite) => await fetchWrapped(urlcat(contentApiV3, `/shop/${shopWebsite}`));
const getAllActiveShops = async () => await fetchWrapped(urlcat(contentApiV3, '/shop/all'));
//for CSR:
//@params: id: number
//for SSR:
//@params: id: number, reqHeaders: { 'cookie': string, 'user-agent': string, 'x-real-ip': string, 'x-forwarded-for': string, 'x-request-id': string }
const getBlogPostData = async (id, reqHeaders) =>
  await fetchWrapped(
    urlcat(contentV3ApiV3, `/blog/post/`),
    reqHeaders ? new PostOptions({ bodyObject: { id, headers: reqHeaders } }) : new PostOptions({ bodyObject: { id } })
  );

export default {
  getBlogData,
  getBlogPostData,
  getShopInfo,
  getAllActiveShops,
};
